import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { DropdownCommonProp } from "../../../../Types/UiKitsType";
import { Href } from "../../../../Constants/Constants";

const HelperCardBody: React.FC<DropdownCommonProp> = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)}>
        <DropdownToggle caret color={item.class}>{item.text}</DropdownToggle>
        <DropdownMenu className="dropdown-block p-3 dark-form">
          <DropdownItem header className="fs-6 fw-bold pb-2 ps-0 text-dark border-bottom-1 pt-0" href={Href}>{item.menulist[0]}</DropdownItem>
          <DropdownItem className="p-0 helper-truncate" href={Href}>{item.menulist[1]}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default HelperCardBody;
